import { render } from "./AuthBlock.vue?vue&type=template&id=6c6c8900&scoped=true"
import script from "./AuthBlock.vue?vue&type=script&lang=js"
export * from "./AuthBlock.vue?vue&type=script&lang=js"

import "./AuthBlock.vue?vue&type=style&index=0&id=6c6c8900&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6c8900"]])

export default __exports__